import React from 'react';
import {Dimensions, View} from 'react-native';
import {createShimmerPlaceholder} from 'react-native-shimmer-placeholder';
import LinearGradient from 'react-native-linear-gradient';
import {RFValue} from 'react-native-responsive-fontsize';
import {useTheme} from 'styled-components/native';

const ShimmerPlaceHolder = createShimmerPlaceholder(LinearGradient);

const SCREEN_W = Dimensions.get('window').width;
const CARD_W = Math.round(SCREEN_W * 0.58);
const CARD_H = Math.round(CARD_W * 1.37);
const ITEM_GAP = 12;
const SIDE_PAD = 24;

export function CouponsShimmer() {
  const theme = useTheme();
  const colors = theme.colors.shimmer_placeholder;

  return (
    <View>
      {/* Carousel */}
      <View style={{marginVertical: RFValue(12)}}>
        <View style={{width: SCREEN_W, overflow: 'hidden'}}>
          <View style={{flexDirection: 'row', paddingLeft: SIDE_PAD}}>
            <ShimmerPlaceHolder
              style={{
                width: CARD_W,
                height: CARD_H,
                borderRadius: RFValue(20),
                marginRight: ITEM_GAP,
              }}
              shimmerColors={colors}
            />
            <ShimmerPlaceHolder
              style={{
                width: CARD_W,
                height: CARD_H,
                borderRadius: RFValue(20),
                opacity: 0.5,
                transform: [{scale: 0.91}],
              }}
              shimmerColors={colors}
            />
          </View>
        </View>

        {/* Dots */}
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'center',
            marginTop: RFValue(12),
            gap: RFValue(5),
          }}>
          {([RFValue(18), RFValue(6), RFValue(6)] as number[]).map((w, i) => (
            <ShimmerPlaceHolder
              key={i}
              style={{width: w, height: RFValue(6), borderRadius: RFValue(3)}}
              shimmerColors={colors}
            />
          ))}
        </View>
      </View>

      {/* Section tabs */}
      <View
        style={{
          flexDirection: 'row',
          paddingHorizontal: SIDE_PAD,
          paddingBottom: RFValue(12),
          gap: RFValue(12),
        }}>
        {[0, 1, 2].map(i => (
          <ShimmerPlaceHolder
            key={i}
            style={{
              width: RFValue(130),
              height: RFValue(85),
              borderRadius: RFValue(16),
            }}
            shimmerColors={colors}
          />
        ))}
      </View>

      {/* ReferralCarousel */}
      <View style={{paddingHorizontal: SIDE_PAD, marginBottom: RFValue(0)}}>
        <ShimmerPlaceHolder
          style={{
            width: SCREEN_W - SIDE_PAD * 2,
            height: RFValue(68),
            borderRadius: RFValue(16),
          }}
          shimmerColors={colors}
        />

      </View>

      {/* CarrinhoProgressCard */}
      <ShimmerPlaceHolder
        style={{
          marginHorizontal: SIDE_PAD,
          marginTop: RFValue(12),
          height: RFValue(140),
          borderRadius: RFValue(20),
          width: SCREEN_W - SIDE_PAD * 2,
        }}
        shimmerColors={colors}
      />
    </View>
  );
}
